import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"mailCancel.small\"><g id=\"envelope\"><path id=\"Vector\" d=\"M17.5 7.54166V4.5C17.5 4.10217 17.342 3.72064 17.0607 3.43934C16.7794 3.15804 16.3978 3 16 3H4C3.60218 3 3.22064 3.15804 2.93934 3.43934C2.65804 3.72064 2.5 4.10217 2.5 4.5V13.5C2.5 14.325 3.175 15 4 15H6.375\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M17.5 5.25L14.9531 7.117M2.5 5.25L8.09375 8.8045\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><g id=\"cancel\"><path id=\"Vector_3\" d=\"M11.5 11.5L17.1 17.1\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_4\" d=\"M17.1 11.5L11.5 17.1\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }